import { useApi } from '@equifinance/shared';
import { Notes, defaultNotes } from '../contexts/notes';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type NotesApiType = {
  getNotes: (id: string) => Promise<Notes>,
  putNotes: (notes: Notes, accountId: string) => Promise<Notes>,
}

export default function useNotesApi(): NotesApiType {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    get, put,
  } = useApi(apiUrl);

  return {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getNotes: (id: string): Promise<Notes> => (async () => defaultNotes)(), // get(`notes/${id}`),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    putNotes: (notes: Notes, accountId: string) => (async () => defaultNotes)(), // put(`checklists/${accountId}`, checklist),
  };
}
